// extracted by mini-css-extract-plugin
export default {"card__post":"card-post_card__post__y3uae","card__post__image":"card-post_card__post__image__0cGwB","card__post__info":"card-post_card__post__info__XX4kL"};